export default __webpack_public_path__ + "static/media/ocado.9936e854.svg";